import React from 'react'
import PropTypes from 'prop-types'
import { Form, Select, Spin } from 'antd'
import { debounce } from 'lodash'
import { getSystemAgentsList } from '@/service/systemControl'
import { renderTextStr, renderPhoneStr } from '@/utils/renderUtils'

const FormItem = Form.Item

const AGENTS_QUERY = {
  pageNumber: 1,
  pageSize: 50,
  orderBy: 'create_time',
  orderDirection: 'desc',
  state: 1
}

function normalizeAgentRecords (body) {
  if (!body || typeof body !== 'object') return []
  if (Array.isArray(body.list)) return body.list
  if (Array.isArray(body.records)) return body.records
  if (Array.isArray(body.data?.list)) return body.data.list
  if (Array.isArray(body.data?.records)) return body.data.records
  return []
}

function agentOption (a) {
  if (!a || a.id == null) return null
  const name = renderTextStr(a.userName)
  const phone = a.phone
  const left = name || `#${String(a.id)}`
  return {
    value: String(a.id),
    label: phone ? `${left} · ${renderPhoneStr(phone)}` : left
  }
}

/**
 * baseProps 契约：
 * - storeOptions：门店下拉 [{ id, value }, ...]（可选，用于筛员工）
 */
class ReloadClientPagesForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    baseProps: PropTypes.object
  }

  static defaultProps = {
    baseProps: {}
  }

  state = {
    storeId: undefined,
    options: [],
    loading: false
  }

  loadSeq = 0

  componentDidMount () {
    this.loadAgents('')
    this.debouncedLoad = debounce((kw) => this.loadAgents(kw), 300)
  }

  componentWillUnmount () {
    if (this.debouncedLoad && typeof this.debouncedLoad.cancel === 'function') {
      this.debouncedLoad.cancel()
    }
  }

  loadAgents = async (keywordRaw) => {
    const kw = typeof keywordRaw === 'string' ? keywordRaw.trim() : ''
    const seq = ++this.loadSeq
    const { storeId } = this.state
    this.setState({ loading: true })
    try {
      const res = await getSystemAgentsList({
        ...AGENTS_QUERY,
        ...(storeId != null && storeId !== '' ? { storeId: String(storeId) } : {}),
        ...(kw !== '' ? { keyword: kw } : {})
      })
      if (seq !== this.loadSeq) return
      const list = normalizeAgentRecords(res?.data ?? {})
      this.setState({
        options: list.map(agentOption).filter(Boolean),
        loading: false
      })
    } catch (e) {
      if (seq !== this.loadSeq) return
      this.setState({ options: [], loading: false })
    }
  }

  handleStoreChange = (storeId) => {
    this.setState({ storeId }, () => {
      this.loadAgents('')
    })
  }

  render () {
    const { form, baseProps } = this.props
    const { storeOptions = [] } = baseProps || {}
    const { options, loading, storeId } = this.state

    return (
      <Form ref={form} layout="vertical">
        <FormItem label="按门店筛员工（可选）">
          <Select
            allowClear
            showSearch
            placeholder="不选则查全部门店在职员工"
            value={storeId}
            optionFilterProp="label"
            options={(storeOptions || []).map((o) => ({
              value: String(o.id),
              label: o.value
            }))}
            onChange={this.handleStoreChange}
          />
        </FormItem>
        <FormItem
          label="客户（员工）"
          name="clientIds"
          rules={[{ required: true, type: 'array', min: 1, message: '请至少选择一名员工' }]}
        >
          <Select
            mode="multiple"
            allowClear
            showSearch
            placeholder="搜索姓名 / 手机 / 账号后多选"
            options={options}
            filterOption={false}
            notFoundContent={loading ? <Spin size="small" /> : '无匹配员工'}
            onSearch={(kw) => {
              if (this.debouncedLoad) this.debouncedLoad(kw)
            }}
            onDropdownVisibleChange={(open) => {
              if (open) this.loadAgents('')
            }}
          />
        </FormItem>
      </Form>
    )
  }
}

export default ReloadClientPagesForm
